/** What the Counter card's number last showed: at which desk, which visit, how often recalled. */
export type Seen = { desk: string; id?: string; recalls: number }

/**
 * Whether the number blinks as the card goes from `prev` to `next`: a visit newly
 * at the desk, or the same visit recalled. Never on the first look or a desk change.
 */
export function blinks(prev: Seen | null, next: Seen): boolean {
  if (!prev || prev.desk !== next.desk || !next.id) return false
  if (prev.id !== next.id) return true
  return next.recalls > prev.recalls
}
